import type { ReactNode } from 'react';

/** A label and its value on one line of the partner summary. */
export function SummaryRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '120px 1fr',
        gap: 10,
        alignItems: 'center',
        minHeight: 26,
      }}
    >
      <span className="nb-eyebrow" style={{ fontSize: 9.5 }}>
        {label}
      </span>
      <span style={{ fontSize: 12.5, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
        {children}
      </span>
    </div>
  );
}
